import script from "./ITeamsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ITeamsMain.vue?vue&type=script&setup=true&lang=js"

import "./ITeamsMain.vue?vue&type=style&index=0&id=644c4939&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-644c4939"]])

export default __exports__